<template>
  <ValidationProvider v-slot="{ errors }">
    <v-autocomplete
      ref="rootCmp"
      outlined
      hide-details
      :items="inputItems"
      :loading="loading"
      :value="value"
      v-on:input="$emit('input',$event)"
      :multiple="true"
      :item-text="itemText"
      :item-value="itemValue"
      :error-messages="errors"
      :search-input.sync="searchInput"
      :filter="filterAlgo"
      :label="label"
    >
      <template v-slot:prepend-item>
        <div class="d-flex">
          <v-btn
            :disabled="!showButtonForSelectFiltered"
            text small
            color="primary"
            class="showAllBtn" @click="selectAllFiltered">
            Выбрать все
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!showButtonForClearAll"
            text
            small
            color="primary"
            class="hideAllBtn"
            @click="clearAll">
            Очистить
          </v-btn>
        </div>
      </template>
    </v-autocomplete>
  </ValidationProvider>
</template>

<script>
export default {
  name: 'MyAutocompleteMultiple',
  props: {
    items: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    itemText: {
      type: String,
      default() {
        return 'name';
      },
    },
    itemValue: {
      type: String,
      default() {
        return 'id';
      },
    },
    value: {
      type: Array,
      default() {
        return null;
      },
    },
    label: {
      type: String,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      searchInput: null,
    };
  },
  computed: {
    inputItems() {
      if (!this.searchInput || this.searchInput.length === 0) {
        if (this.selectedItems.length > 0) {
          return this.selectedItems;
        }
      }
      return this.items;
    },
    filterItems() {
      if (!this.searchInput || this.searchInput.length === 0) {
        return this.items;
      }
      return this.items.filter(
        (item) => this.filterAlgo(item, this.searchInput, this.getTextFromItem(item)),
      );
    },
    canSelectedFromFiltered() {
      return this.filterItems.filter(
        (item) => this.value.indexOf(this.getValueFromItem(item)) === -1,
      );
    },
    selectedItems() {
      return this.items.filter((item) => this.value.indexOf(this.getValueFromItem(item)) !== -1);
    },
    showButtonForClearAll() {
      return this.value.length > 0;
    },
    showButtonForSelectFiltered() {
      return this.canSelectedFromFiltered.length > 0;
    },
  },
  methods: {
    isObject(variable) {
      return typeof variable === 'object' && variable !== null;
    },
    getTextFromItem(item) {
      if (!this.isObject(item)) {
        return item;
      }

      return item[this.itemText];
    },
    getValueFromItem(item) {
      if (!this.isObject(item)) {
        return item;
      }

      return item[this.itemValue];
    },
    filterAlgo(item, queryText, itemText) {
      if (!itemText) return false;
      return itemText.toString().toLowerCase().indexOf(queryText.toLowerCase()) > -1;
    },
    selectAllFiltered() {
      this.canSelectedFromFiltered.forEach((item) => this.$refs.rootCmp.selectItem(item));
    },
    clearAll() {
      this.$refs.rootCmp.setValue([]);
      this.$refs.rootCmp.blur();
    },
  },
};
</script>

<style scoped>

</style>
